import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";

import API from "../../axios";
import useQuery from "../../hooks/useQuery";
import { Label } from "./Onboarding.styles";

// 360dialog redirects with `channels=[id1,id2]`.
const parseChannels = (raw) =>
  (raw || "")
    .replace(/^\[|\]$/g, "")
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);

const MESSAGES = {
  linking: "Conectando WhatsApp, no cierres esta ventana...",
  linked: "Número vinculado con éxito, puedes cerrar esta ventana.",
  failed:
    "No se pudo vincular el número. Cierra esta ventana e inténtalo de nuevo desde Canales vinculados.",
  missing:
    "No encontramos los datos de la vinculación. Cierra esta ventana e inténtalo de nuevo desde Canales vinculados.",
};

const LinkMessage = ({ status }) => (
  <main
    style={{
      width: "100vw",
      height: "100vh",
      padding: "50px",
    }}
  >
    <Label>{MESSAGES[status]}</Label>
  </main>
);

/**
 * One link attempt. Its state starts at "linking" on every mount, so a result
 * never outlives the attempt that produced it.
 */
const LinkAttempt = ({ client, channels }) => {
  const [status, setStatus] = useState("linking");

  useEffect(() => {
    let active = true;
    API.post("/link-whatsapp", { client, channels })
      .then(() => active && setStatus("linked"))
      .catch((error) => {
        Sentry.captureException(error, {
          tags: { component: "SuccessfulLink", op: "linkWhatsapp" },
        });
        if (active) setStatus("failed");
      });
    return () => {
      active = false;
    };
    // The parent remounts this component (via `key`) for every new attempt.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LinkMessage status={status} />;
};

/**
 * Redirect target of 360dialog's Integrated Onboarding (`redirect_url`):
 * links the granted channels with POST /link-whatsapp and only claims success
 * once the backend answered OK. Each navigation that carries a redirect mounts
 * its own attempt; leaving the redirect unmounts it, so going back or arriving
 * again never shows an earlier result.
 */
const SuccessfulLink = () => {
  const client = useQuery("client");
  const channels = parseChannels(useQuery("channels"));
  const { key: navigationKey = "" } = useLocation();

  if (!client || channels.length === 0) return <LinkMessage status="missing" />;

  return (
    <LinkAttempt
      key={`${navigationKey}|${client}|${channels.join(",")}`}
      client={client}
      channels={channels}
    />
  );
};

export default SuccessfulLink;
